// Tekninen loki (suunnitelman kohta 11.5). Erillään retkipäiväkirjasta.
//
// Loki on vain puhelimessa. Siihen ei koskaan kirjata sijainteja eikä
// kuvia: vain tapahtuman nimi, aika ja lyhyt kuvaus. Jakaminen on
// vapaaehtoista, ja käyttäjä näkee koko sisällön ennen kopiointia.

import { storage } from "./storage.js";

const KEY = "diagnostics";
const MAX_ENTRIES = 200;

export function logEvent(event, detail = "", level = "info") {
  const entries = storage.get(KEY, []);
  entries.push({ t: Date.now(), level, event, detail: String(detail).slice(0, 300) });
  storage.set(KEY, entries.slice(-MAX_ENTRIES));
}

export function readLog() {
  return storage.get(KEY, []);
}

export function clearLog() {
  storage.remove(KEY);
}

/** Lokin tekstimuoto jakamista varten. */
export function formatLog(entries = readLog()) {
  const lines = entries.map((e) => {
    const d = new Date(e.t);
    const stamp = d.toLocaleString("fi-FI", { timeZone: "Europe/Helsinki" });
    return `${stamp}  ${e.level.toUpperCase().padEnd(5)}  ${e.event}${e.detail ? `: ${e.detail}` : ""}`;
  });
  return [`Tilehunting tekninen loki, ${entries.length} merkintää`, `Selain: ${navigator.userAgent}`, "", ...lines].join("\n");
}
